export default {
  UpcomingEvents: 1,
  PastEvents: 2,
  TeamAdmins: 3,
  Labels: 4,
  TeamSettings: 5,
  GlobalElements: 6,
};
